import React from 'react';
import classNames from 'classnames/bind';

import { Skeleton } from 'components';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const SkeletonCtn = () => (
  <div className={cx('wrapper')}>
    <div className={cx('option-wrapper')}>
      {Array.from(
        Array(3).keys(),
      ).map((skeleton) => (
        <Skeleton
          key={skeleton}
        />
      ))}
    </div>
  </div>
);
